import React, { Component } from 'react'
import Breadcumb from '../../../components/Breadcumb/Breadcumb'
import { GetUserLogin, Alerts } from '../../../helpers'
import Container from '@material-ui/core/Container';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { Button, Grid, TextField } from '@material-ui/core';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
const BreadcrumbData = [
    {
        id: 1,
        page_title: "Dashboard",
        page_path: "/",
        icon: "tachometer",
    },
    {
        id: 2,
        page_title: "Change Password",
        page_path: "/app/profile",
        icon: "lock",
    }
]
export default class ChangePassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isValidCurrentPassword: false,
            successMessage: '',
            current_password: '',
            current_password_error: '',
            isDesableInput: false,
            isLoading: false,
            new_password: '',
            c_new_password: '',
            formValid: false,
            validNewPassword: false,
            validCNewPassword: false,
            formErrors: { new_password: '', c_new_password: '' },

        }
    }

    handleCurrentPassword = (e) => {
        this.setState({
            current_password: e.target.value
        }, () => {
            this.validateCurrentPassword();
        });
    }
    validateCurrentPassword = () => {
        const { current_password } = this.state;
        if (current_password === '') {
            this.setState({
                current_password_error: "Please enter current password !"
            })
        } else {
            this.setState({
                current_password_error: ""
            })
        }
    }

    handleCheckPassword = async () => {
        const { current_password } = this.state;
        if (current_password !== '') {
            this.setState({
                isLoading: true
            })
            const data = {
                password: current_password
            }
            let resp = await GetUserLogin.checkUserCurrentPassword(data);
            if (resp) {
                if (resp.status === true) {
                    this.setState({
                        isValidCurrentPassword: true,
                        isDesableInput: true,
                        successMessage: resp.message
                    })
                } else {
                    this.setState({
                        current_password_error: resp.message
                    })
                }
                this.setState({
                    isLoading: false
                })
            }

        } else {
            this.setState({
                current_password_error: "Please enter your current password !"
            })
        }

    }

    handleUserInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value },
            () => { this.validateField(name, value) });


    }

    validateField(fieldName, value) {
        let fieldValidationErrors = this.state.formErrors;
        let { validNewPassword, validCNewPassword } = this.state;

        switch (fieldName) {
            case 'new_password':
                validNewPassword = value.length !== 0;
                fieldValidationErrors.new_password = validNewPassword ? '' : ' Please enter your new password.';
                break;

            case 'c_new_password':
                validCNewPassword = value.length !== 0;
                fieldValidationErrors.c_new_password = validCNewPassword ? '' : ' Please confirm your new password.';
                break;
            default:
                break;
        }
        this.setState({
            formErrors: fieldValidationErrors,
            validNewPassword: validNewPassword,
            validCNewPassword: validCNewPassword,
        }, this.validateForm);
    }


    validateForm() {
        let { validNewPassword, validCNewPassword } = this.state;
        this.setState({ formValid: validNewPassword && validCNewPassword });
    }
    handleSubmit = async (e) => {
        e.preventDefault();
        var userData = JSON.parse(sessionStorage.getItem('userData'));
        let fieldValidationErrors = this.state.formErrors;
        const { formValid, new_password, c_new_password } = this.state;
        if (formValid) {
            if (new_password === c_new_password) {
                const data = {
                    new_password:new_password
                }
               

                let resp = await GetUserLogin.getUserPasswordUpdate(userData.id, data);
                if (resp) {
                    if(resp.status === true){
                        Alerts.alertMessage(resp.message, "Thanks !", "success");
                        setTimeout(function () {
                            window.location.href = '/app/change-password'; 
                        }, 4000);
                        
                    }else{
                        Alerts.alertMessage(resp.message, "Sorry !", "danger");
                    }
                }
                fieldValidationErrors.c_new_password = ''
                this.setState({
                    formErrors: fieldValidationErrors,
                });
            } else {
                fieldValidationErrors.c_new_password = 'Confirm password does not match'
                this.setState({
                    formErrors: fieldValidationErrors,
                });
            }
        }


    }



    render() {
        const { isValidCurrentPassword, successMessage, current_password, current_password_error, isDesableInput, isLoading, new_password, c_new_password, formErrors } = this.state;

        return (
            <>
                <Breadcumb items={BreadcrumbData} />
                <div className="page-wrapper">
                    <Container>
                        <Card className="card mt20">
                            <CardContent>
                                <form className="form" onSubmit={this.handleSubmit} noValidate>
                                    <Box m={2} >
                                        <Typography variant="h5" gutterBottom>
                                            Change Password
                                        </Typography>
                                        <Grid container>
                                            <Grid item lg={6} sm={6}>
                                                <FormControl fullWidth={true}>
                                                    <InputLabel htmlFor="standard-adornment-password">Current Password</InputLabel>
                                                    <Input
                                                        id="standard-adornment-password"
                                                        type="password"
                                                        fullWidth={true}
                                                        disabled={isDesableInput}
                                                        value={current_password}
                                                        onChange={this.handleCurrentPassword}
                                                        endAdornment={
                                                            <InputAdornment position="end">
                                                                <IconButton
                                                                    aria-label="toggle password visibility"
                                                                    onClick={this.handleCheckPassword}
                                                                    color="primary"
                                                                    disabled={isDesableInput}
                                                                >
                                                                    {isLoading ? <CircularProgress /> : <ArrowRightAltIcon />}
                                                                </IconButton>
                                                            </InputAdornment>
                                                        }
                                                    />
                                                    {current_password_error !== '' ? <div className="error-help"> <HighlightOffIcon /> {current_password_error}</div> : null}

                                                    {isValidCurrentPassword ? <div className="success-help"> <CheckCircleIcon /> {successMessage} </div> : null}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                    <Box m={2} >

                                        <Grid container m="2rem">
                                            <Grid item lg={6} sm={6}>
                                                {
                                                    isValidCurrentPassword ? <>

                                                        <Grid container spacing={3}>
                                                            <Grid item lg={12} sm={12}>
                                                                <TextField
                                                                    type="password"
                                                                    label="New Password"
                                                                    variant="filled"
                                                                    fullWidth={true}
                                                                    size="small"
                                                                    name="new_password"
                                                                    value={new_password}
                                                                    onChange={this.handleUserInput}
                                                                />
                                                                {formErrors.new_password !== '' ? <div className="error-help"> <HighlightOffIcon /> {formErrors.new_password}</div> : null}

                                                            </Grid>
                                                            <Grid item lg={12} sm={12}>
                                                                <TextField
                                                                    type="password"
                                                                    label="Confirm New Password"
                                                                    variant="filled"
                                                                    fullWidth={true}
                                                                    size="small"
                                                                    name="c_new_password"
                                                                    value={c_new_password}
                                                                    onChange={this.handleUserInput}
                                                                />
                                                                {formErrors.c_new_password !== '' ? <div className="error-help"> <HighlightOffIcon /> {formErrors.c_new_password}</div> : null}
                                                            </Grid>
                                                        </Grid>
                                                        <Box pt={2}>
                                                            <Button disabled={!this.state.formValid} variant="contained" color="primary" type="submit">Update Now</Button>
                                                        </Box>
                                                    </>
                                                        : null
                                                }
                                            </Grid>
                                        </Grid></Box>
                                </form>
                            </CardContent>

                        </Card>

                    </Container>
                </div>
            </>
        )
    }
}
